import PropTypes from "prop-types";
import "../styles/testimonial-video.css";

const TestimonialVideo = ({ videoId, title }) => {
  return (
    <div className="testimonial-video">
      <iframe
        src={`https://www.youtube.com/embed/${videoId}?modestbranding=1&rel=0&showinfo=0`}
        title={title || "Testimonial Video"}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
};

TestimonialVideo.propTypes = {
  videoId: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default TestimonialVideo;
